import styled from '@emotion/styled';
import { ReactComponent as CloudBottomLeft } from '../assets/cloud-bottom-left.svg';
import { ReactComponent as CloudBottomRight } from '../assets/cloud-bottom-right.svg';

export const ImageBottomLeft = styled(CloudBottomLeft)({
    position: 'absolute',
    left: 0,
    bottom: 0,
    zIndex: -1,
});

export const ImageBottomRight = styled(CloudBottomRight)({
    position: 'absolute',
    right: 0,
    bottom: 0,
    zIndex: -1,
});
